<app-modal
  [title]="'Servicios del contacto'"
  [showCloseButton]="true"
  (onCloseClick)="closeModal()"
>
    <app-icon-button *hasPermission="'prospectos:create'"
      modal-header-actions
      icon="add"
      tooltip="Asociar servicio"
      (onClick)="openCreateModal()"
    />

    <app-data-table
      [columns]="columns"
      [data]="contactosServicios ?? []"
      [loading]="loading"
    >
      <ng-template appTableCell="acciones" let-item let-index="index">
        <app-delete-trigger *hasPermission="'prospectos:delete'"
          [title]="'Eliminar servicio'"
          [disabled]="deleting && (index === deletingIndex)"
          (clickDeleteEvent)="delete(item.id, index)"
        />
      </ng-template>
    </app-data-table>
</app-modal>
